import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';

export interface IGetSiteSettingsForServerAdminParams {
  id: string;
}

export type IGetSiteSettingsForServerAdminResult = IResult & ISiteSettingsForServerAdmin;

export class GetSiteSettingsForServerAdminRequest
  extends Request<IGetSiteSettingsForServerAdminParams, IGetSiteSettingsForServerAdminResult>
{
  constructor(params: IGetSiteSettingsForServerAdminParams) {
    super('getSiteSettingsForServerAdmin', params);
  }
}
